import { buildRoute } from '@direct-frontend/modules-router';

export const NOTIFICATIONS_SEARCH_PARAM_NOTIFICATION_ID = 'notification_id';

export const notificationsRoute = buildRoute('/notifications');
